// globals: jQuery

import cardConnectIframeAbstract from './cardConnectFrameAbstract';

var cardConnectIframeDialog;

(function($) {
    cardConnectIframeDialog = new cardConnectIframeAbstract({
        formSelector: '#cardConnectFrameFormDialog',
        frameContainer: 'dialogForm_cardConnectFrame',
        cardConnectParamsToFormSelector: '.credit-card-form',
        iframeLocation: 'profile',
        cssRules: [
            'input{height:24px;padding:4px;float:right;width:330px;font-size:12px;font-weight:bold;border-width:1px;border-radius:4px;}',
            'label{display:inline-block;float:left;font-size:12px;font-weight:bold;font-family:Tahoma,Arial;width:120px;text-align:right;padding-right:20px;margin-top:11px;margin-left:32px;}',
            'select{width:161px;height:35px;padding:5px;margin-right:10px;border-radius:4px;background-color:white;margin-top:16px;margin-bottom:16px;}',
            '.error{color:red;}',
            'br{display:none}',
            '@media (max-width: 480px) {input{width:90%;} label {display:flex; margin-left: 0;text-align:left; margin-bottom:12px}}',
            '@media (max-width: 480px) {select{margin-bottom: 5px;margin-top: 5px;width:45%;}}'
        ],
        frameOptions : {
            useexpiry : 'true',
            usecvv : 'true',
            cardlabel : 'Card Number:',
            expirylabel : 'Expiration:',
            cvvlabel : 'CVV:',
            orientation : 'custom',
            placeholdercvv: 'Code',
            placeholdermonth: 'Month',
            placeholderyear: 'Year',
            unique: false,
            formatinput : true,
            autofocus : true,
            invalidinputevent : true,
            enhancedresponse: true
        }
    });

})(jQuery);

export default cardConnectIframeDialog;
